import React from 'react';
import PropTypes from 'prop-types';

import {
  MotifButton,
  MotifModal,
  MotifModalHeader,
  MotifIcon,
  MotifModalBody,
  MotifModalFooter,
} from '@ey-xd/motif-react';
import { IconoirWarningCircle } from '@ey-xd/motif-icon';

const DownloadChecklistsModal = ({
  showDownloadChecklistsModal,
  downloadType,
  modalTitle,
  modalContent,
  selectedChecklists,
  toggleShowDownloadChecklistsModal,
  handleDownloadChecklists,
}) => {
  const HeaderWrapper = ({ children }) => (
    <div
      style={{
        display: 'flex',
        alignItems: 'start',
        justifyContent: 'center',
      }}
    >
      {children}
    </div>
  );

  const closeButtonProps = {
    title: 'Close download checklists modal',
    'aria-label': 'Close download checklists modal',
    'data-testid': 'close',
  };

  const showHideDownloadChecklistsModal = () => {
    toggleShowDownloadChecklistsModal(downloadType);
  };

  return (
    <MotifModal
      variant="alt"
      show={showDownloadChecklistsModal}
      onClose={showHideDownloadChecklistsModal}
      data-testid="DownloadChecklistsModal"
    >
      <MotifModalHeader closeButtonProps={closeButtonProps}>
        <HeaderWrapper>
          {/* <MotifIcon style={{ color: '#F95D54' }} iconFunction={IconoirWarningCircle} size='24'   /> */}
          <span className="ml-0">{modalTitle}</span>
        </HeaderWrapper>
      </MotifModalHeader>
      <MotifModalBody>
        <span className="checklistActionMsg">{modalContent}</span>
        <br />
        <span className="checklistActionMsg">
          You have selected {selectedChecklists?.length} checklist(s).
        </span>
      </MotifModalBody>
      <MotifModalFooter>
        <MotifButton
          variant="secondary"
          className="right"
          data-testid="Cancel"
          type="button"
          onClick={showHideDownloadChecklistsModal}
        >
          Cancel
        </MotifButton>
        <MotifButton
          className="right"
          data-testid="Download"
          type="button"
          onClick={() => handleDownloadChecklists(downloadType)}
        >
          Download
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  );
};

DownloadChecklistsModal.propTypes = {
  showDownloadChecklistsModal: PropTypes.bool,
  downloadType: PropTypes.string,
  modalTitle: PropTypes.string,
  modalContent: PropTypes.string,
  selectedChecklists: PropTypes.array,
  toggleShowDownloadChecklistsModal: PropTypes.bool,
  handleDownloadChecklists: PropTypes.func,
};

export default DownloadChecklistsModal;
